export enum UserRole {
  FULL_ADMIN = 'FULL_ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
}

export interface CurrentUser {
  userRoles: string[];
}

export interface CurrentUserResponse {
  userRoles: string[];
}
